import React from "react";
import { cn } from "@/lib/utils";

const toneFor = (pct) => {
  if (pct >= 85) return "bg-emerald-600";
  if (pct >= 70) return "bg-amber-600";
  return "bg-rose-600";
};

export const ConfidenceMeter = ({ value, className }) => {
  const pct = Math.round((value || 0) * 100);
  const tone = toneFor(pct);
  return (
    <div className={cn("flex items-center gap-2 font-mono text-xs", className)}>
      <div className="h-1.5 w-24 rounded-full bg-muted overflow-hidden">
        <div className={cn("h-full", tone)} style={{ width: `${pct}%` }} />
      </div>
      <span className="tabular-nums text-foreground">{pct}%</span>
    </div>
  );
};

export default ConfidenceMeter;
